import { FC } from "react";
import dynamic from "next/dynamic";
import { useTheme } from "styled-components";
import { IAdsBillBoardProps } from "./AdsBillBoard";

const AdsBillBoard = dynamic(() => import("./AdsBillBoard"), { ssr: false });

const AdsBillBoardShimmer: FC<IAdsBillBoardProps> = (props) => {
  const { enable3rdParty, isMobile, isUserLocationCountryAllowed,memberData } = useTheme();

  if (memberData?.is_pro_buyer) return null;
  if (!enable3rdParty) return null;
  //if (isMobile && !isUserLocationCountryAllowed) return null;
  return <AdsBillBoard {...props} />;
};

export default AdsBillBoardShimmer;
